export default {
  ie_ie: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: '',
      country_link: ''
    },
    logo: 'just-eat',
    title: 'Free delivery on match days ⚽',
    subtitle: 'On Burger King',
    info:
      'Get all set for the UEFA Champions League action with Just Eat. Enjoy free delivery on Tuesdays and Wednesdays from Burger King.',
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in and get ready for the action.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.just-eat.ie/'
    },
    restaurants: [
      {
        name: 'Burger King',
        image: 'burger-king',
        link: 'https://www.just-eat.ie/takeaway/brands/burger-king'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        '- Free delivery on Burger King® is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4.',
        '- Service fees might still apply'
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.co.uk/info/cookies-policy',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.justeat.app.ie&hl=en_GB&gl=US',
      apple:
        'https://apps.apple.com/ie/app/just-eat-ireland-food-delivery/id706000490'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.ie/info/terms-and-conditions'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.ie/info/privacy-policy'
    },
    copyright: '© 2022 JustEat'
  },
  dk_en: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.just-eat.dk/en/deals/ucl-proposition/'
        },
        {
          logo: 'dk',
          url: 'https://www.just-eat.dk/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'just-eat',
    title: 'Free delivery on match days ⚽',
    subtitle: 'on big brands and local favourites',
    info: `Get all set for the UEFA Champions League matches with Just Eat. Enjoy free delivery on Tuesdays and Wednesdays on KFC, Domino's and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area.`,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.just-eat.dk/en'
    },
    restaurants: [
      {
        name: 'KFC',
        image: 'kfc',
        link: 'https://www.just-eat.dk/en/kfc'
      },
      {
        name: `Domino's`,
        image: 'dominos',
        link: 'https://www.just-eat.dk/en/dominos'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.just-eat.dk/en'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on KFC and Domino's is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4.`,
        '- Service fees might still apply',
        `- A discounted fee for KFC and Domino's might apply if order classifies as long distance delivery.`
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.dk/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.justeat.app.dk&hl=en&gl=US',
      apple:
        'https://apps.apple.com/dk/app/just-eat-dk-levering-af-mad/id600932477'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.dk/vilkar-og-betingelser'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.dk/en/privacy-statement'
    },
    copyright: '© 2022 JustEat'
  },
  dk_dk: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'dk',
          url: 'https://www.just-eat.dk/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.dk/en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'just-eat',
    title: 'Gratis levering på kampdage ⚽',
    subtitle: 'På kendte kæder & lokale favoritter',
    deal: '',
    info: `Gør alt klar til dine UEFA Champions League-aftener med Just Eat. Få gratis levering tirsdage og onsdage hos KFC, Domino’s og lokale favoritter. Du skal blot filtrere efter "Gratis levering på kampdage" for at finde restauranter i dit område. `,
    matches: {
      title: 'Kampdage:',
      dates: [
        'Kvartfinaler, første kamp - tirsdag den 5. april og onsdag den 6. april',
        'Kvartfinaler, anden kamp - tirsdag den 12. april og onsdag den 13. april',
        'Semifinaler, første kamp - tirsdag den 26. april og onsdag den 27. april',
        'Semifinaler, anden kamp - tirsdag den 3. maj og onsdag den 4. maj'
      ],
      outro: 'Bestil mad hjem, glæd dig til kampen og vent på første fløjt.'
    },
    button: {
      text: 'Bestil nu',
      url: 'https://www.just-eat.dk'
    },
    restaurants: [
      {
        name: 'KFC',
        image: 'kfc',
        link: 'https://www.just-eat.dk/kfc'
      },
      {
        name: `Domino's`,
        image: 'dominos',
        link: 'https://www.just-eat.dk/dominos'
      },
      {
        name: 'Lokale favoritter',
        image: 'house-icon',
        link: 'https://www.just-eat.dk'
      }
    ],
    terms: {
      title: 'Vilkår og betingelser: ',
      conditions: [
        '- Kunden skal bestille en minimum ordreværdi per restaurant. ',
        `- Gratis levering på KFC, Domino’s gælder kun den 5.-6., 12.-13., 26.-27. april og 3.- 4. maj.`,
        '- Servicegebyrer kan stadig være gældende.',
        `- Et gebyr for KFC, Domino’s kan gælde, hvis ordren klassificeres som langdistancelevering.`
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.justeat.app.dk&hl=en&gl=US',
      apple:
        'https://apps.apple.com/dk/app/just-eat-dk-levering-af-mad/id600932477'
    },
    conditions: {
      link: 'Vilkår & Betingelser',
      url: 'https://www.just-eat.dk/vilkar-og-betingelser'
    },
    privacy: {
      link: 'Privatlivserklæring',
      url: 'https://www.just-eat.dk/privatlivspolitik'
    },
    copyright: '© 2022 JustEat'
  },
  es_es: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: []
    },
    logo: 'just-eat',
    title: 'Envío gratis los días de partido ⚽',
    subtitle: 'En Burger King, KFC, Telepizza ',
    deal: 'y muchos restaurantes más',
    info: `Disfruta a lo grande de la UEFA Champions League con Just Eat. Aprovecha la promoción de envío gratis en Burger King, KFC, Telepizza y muchos más restaurantes, todos los martes y miércoles. Utiliza el filtro de Envío gratis con el logo de la UEFA Champions League para encontrar los restaurantes de tu zona con esta deliciosa oferta. `,
    matches: {
      title: 'Días de partido',
      dates: [
        'Cuartos de final: partidos de ida - martes 5 de abril y miércoles 6 de abril',
        'Cuartos de final: partidos de vuelta - martes 12 de abril y miércoles 13 de abril',
        'Semifinales: partidos de ida - martes 26 de abril y miércoles 27 de abril',
        'Semifinales: partidos de vuelta - martes 3 de mayo y miércoles 4 de mayo'
      ],
      outro: 'Pide tus favoritos y tenlo todo listo para el saque inicial.'
    },
    button: {
      text: 'Pide ahora',
      url: 'https://www.just-eat.es'
    },
    restaurants: [
      {
        name: `Burger King`,
        image: 'burger-king',
        link: 'https://www.just-eat.es/a-domicilio/cadenas/burger-king'
      },
      {
        name: 'KFC',
        image: 'kfc',
        link: 'https://www.just-eat.es/a-domicilio/cadenas/kfc'
      },
      {
        name: 'Telepizza',
        image: 'telepizza',
        link: 'https://www.just-eat.es/a-domicilio/cadenas/telepizza'
      },
      {
        name: 'y muchos más',
        image: 'house-icon',
        link: 'https://www.just-eat.es'
      }
    ],
    terms: {
      title: 'Términos y condiciones: ',
      conditions: [
        '- La promoción de envío gratis en Burger King, KFC, Telepizza es válida el 5, 6, 12, 13, 26, 27 de abril y el 3 y 4 de mayo.',
        `- La promoción está sujeta al pedido mínimo de cada restaurante (Burger King = 16€, KFC = 8€, Telepizza = se aplica el pedido mínimo previsto para cada restaurante).`,
        '- Se pueden aplicar cuotas de servicio al coste del pedido.'
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.justeat.app.es&hl=en_GB&gl=US',
      apple:
        'https://apps.apple.com/es/app/just-eat-order-food-delivery/id615238455?l=en'
    },
    conditions: {
      link: 'Términos y condiciones',
      url: 'https://www.just-eat.es/info/terminos-y-condiciones'
    },
    privacy: {
      link: 'Política de privacidad',
      url: 'https://www.just-eat.es/info/politica-de-privacidad'
    },
    copyright: '© 2022 JustEat'
  },
  it_it: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: []
    },
    logo: 'just-eat',
    title: 'Consegna gratis durante le partite ⚽',
    subtitle: `Da KFC, Old Wild West, Domino's`,
    deal: `e tanti altri ristoranti`,
    info: `Goditi le partite di UEFA Champions League con Just Eat. Approfitta della consegna gratuita il martedì e il mercoledì da KFC, Old Wild West, Domino’s e tanti altri ristoranti. Dovrai solo utilizzare il filtro Consegna Gratis durante i giorni delle partite per trovare i ristoranti nella tua zona.`,
    matches: {
      title: 'I giorni delle partite:',
      dates: [
        'Quarti di finale, partite di andata - martedì 5 aprile e mercoledì 6 aprile',
        'Quarti di finale, partite di ritorno - martedì 12 aprile e mercoledì 13 aprile',
        'Semifinali, partite di andata - martedì 26 aprile e mercoledì 27 aprile',
        'Semifinali, partite di ritorno - martedì 3 maggio e mercoledì 4 maggio'
      ],
      outro: 'Ordina ora e preparati al fischio d’inizio.'
    },
    button: {
      text: 'Ordina ora',
      url: 'https://www.just-eat.it'
    },
    restaurants: [
      {
        name: 'KFC',
        image: 'kfc',
        link: 'https://www.justeat.it/domicilio/catene-ristoranti/kfc'
      },
      {
        name: 'Old Wild West',
        image: 'old-wild-west',
        link: 'https://www.justeat.it/domicilio/catene-ristoranti/old-wild-west'
      },
      {
        name: `Domino's`,
        image: 'dominos',
        link: 'https://www.justeat.it/domicilio/catene-ristoranti/dominos-pizza'
      },
      {
        name: 'Altri ristoranti',
        image: 'house-icon',
        link: 'https://www.just-eat.it'
      }
    ],
    terms: {
      title: 'Termini e condizioni: ',
      conditions: [
        '- Il cliente deve raggiungere la spesa minima del ristorante. ',
        `- Consegna gratis da KFC, Old Wild West, Domino’s valida solo il 5, 6, 12, 13, 26, 27 aprile e il 3 e 4 maggio. `
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.justeat.app.it&hl=en_GB&gl=US',
      apple:
        'https://apps.apple.com/gb/app/just-eat-food-delivery-uk/id566347057'
    },
    conditions: {
      link: 'Termini e condizioni',
      url: 'https://www.justeat.it/informazioni/termini-e-condizioni'
    },
    privacy: {
      link: 'Privacy policy',
      url: 'https://www.justeat.it/informazioni/privacy-policy'
    },
    copyright: '© 2022 JustEat'
  },
  fr_en: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.just-eat.fr/en/deals/ucl-proposition/'
        },
        {
          logo: 'fr',
          url: 'https://www.just-eat.fr/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'just-eat',
    title: 'Free delivery on match days ⚽',
    subtitle: `on McDonald's™ and local favourites`,
    info: `Get all set for the UEFA Champions League matches with Just Eat. Enjoy free delivery on Tuesdays and Wednesdays on McDonald's™ and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area. `,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.just-eat.fr/en/'
    },
    restaurants: [
      {
        name: `McDonald's™`,
        image: 'mc-donalds',
        link: 'https://www.just-eat.fr/en/mcdonalds'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.just-eat.fr/en/'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on McDonald's™ is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4. `,
        '- Service fees might still apply',
        `- A discounted fee for McDonald's™ might apply if order classifies as long distance delivery.`
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.fr/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.justeat.app.fr&hl=en_GB&gl=US',
      apple:
        'https://apps.apple.com/fr/app/just-eat-fr-livraison-repas/id911826430?l=en'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.fr/en/terms-of-use'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.fr/en/privacy-statement'
    },
    copyright: '© 2022 JustEat'
  },
  fr_fr: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'fr',
          url: 'https://www.just-eat.fr/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.fr/en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'just-eat',
    title: 'Frais de livraison offerts ⚽',
    subtitle: `Chez McDonald's™ et de nombreux restaurants`,
    deal: ``,
    info: `Soyez prêt pour les matchs de la Ligue des champions de l’UEFA avec Just Eat. Profitez des frais de livraison offerts les mardis et mercredis chez McDonald's™ ainsi qu'auprès de vos meilleures adresses locales. Utilisez simplement le filtre « Livraison gratuite les jours de match » pour trouver des restaurants dans votre quartier. `,
    matches: {
      title: 'Jours de match :',
      dates: [
        'Quarts de finale, match aller - mardi 5 avril et mercredi 6 avril',
        'Quarts de finale, match retour - mardi 12 avril et mercredi 13 avril',
        'Demi-finales, match aller - mardi 26 avril et mercredi 27 avril',
        'Demi-finales, match retour - mardi 3 mai et mercredi 4 mai'
      ],
      outro: 'Passez commande, faites-vous plaisir et attendez le coup d’envoi.'
    },
    button: {
      text: 'Commandez maintenant',
      url: 'https://www.just-eat.fr/'
    },
    restaurants: [
      {
        name: `McDonald's™`,
        image: 'mc-donalds',
        link: 'https://www.just-eat.fr/mcdonalds'
      },
      {
        name: 'Vos restaurants préférés',
        image: 'house-icon',
        link: 'https://www.just-eat.fr/'
      }
    ],
    terms: {
      title: 'Conditions générales de vente : ',
      conditions: [
        '- Le client doit respecter un montant minimum de commande par restaurant. ',
        `- Frais de livraison offerts chez McDonald's™ valable seulement les 5, 6, 12, 13, 26, 27 avril et 3, 4 mai. `,
        '- Des frais de service peuvent s’appliquer.',
        `- Des frais pour McDonald's™ peuvent s’appliquer si la commande est classée comme une livraison longue distance.`
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.justeat.app.fr&hl=en_GB&gl=US',
      apple:
        'https://apps.apple.com/fr/app/just-eat-fr-livraison-repas/id911826430?l=en'
    },
    conditions: {
      link: `Conditions Générales`,
      url: 'https://www.just-eat.fr/conditions-d-utilisation'
    },
    privacy: {
      link: `Déclaration de confidentialité`,
      url: 'https://www.just-eat.fr/privacy-statement'
    },
    copyright: '© 2022 JustEat'
  },
  de_en: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.lieferando.de/en/deals/ucl-proposition/'
        },
        {
          logo: 'de',
          url: 'https://www.lieferando.de/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'lieferando',
    title: 'Free delivery on match days ⚽',
    subtitle: `On big brands and local favourites`,
    info: `Get all set for the UEFA Champions League matches with Lieferando. Enjoy free delivery on Tuesdays and Wednesdays on Domino’s, KFC, Burger King® and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area.`,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.lieferando.de/en/'
    },
    restaurants: [
      {
        name: `Burger King®`,
        image: 'burger-king',
        link: 'https://www.lieferando.de/en/burger-king'
      },
      {
        name: `KFC`,
        image: 'kfc',
        link: 'https://www.lieferando.de/en/kfc'
      },
      {
        name: `Domino's`,
        image: 'dominos',
        link: 'https://www.lieferando.de/en/dominos'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.lieferando.de/en/'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on Domino’s, KFC and Burger King® is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4. `,
        '- Service fees might still apply.',
        `- A discounted fee for Domino’s, KFC and Burger King® might apply if order classifies as long distance delivery.`
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.lieferando.de/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.yopeso.lieferando&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/gb/app/lieferando-de/id419724490'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.lieferando.de/agb'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.lieferando.de/en/privacy-statement'
    },
    copyright: '© 2022 lieferando.de'
  },
  de_de: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'de',
          url: 'https://www.lieferando.de/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.lieferando.de/en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'lieferando',
    title: 'Gratis Lieferung an Spieltagen ⚽',
    subtitle: `Bei Domino’s, KFC, Burger King® uvm.`,
    deal: '',
    info: `Mach dich bereit für die Spiele der UEFA Champions League mit Lieferando. Domino’s, KFC, Burger King® und lokale Lieblingsrestaurants liefern dienstags und mittwochs kostenlos. Einfach nach “Gratis Lieferung an Spieltagen” filtern und Restaurants in deiner Nähe finden. `,
    matches: {
      title: 'Spieltage:',
      dates: [
        'Viertelfinale, Hinspiele – Dienstag, 5. April und Mittwoch, 6. April',
        'Viertelfinale, Rückspiele – Dienstag, 12. April und Mittwoch, 13. April',
        'Halbfinale, Hinspiele – Dienstag, 26. April und Mittwoch, 27. April',
        'Halbfinale, Rückspiele – Dienstag, 3. Mai und Mittwoch, 4. Mai'
      ],
      outro: 'Bestell dir etwas Leckeres und warte gespannt auf den Anpfiff.'
    },
    button: {
      text: 'Jetzt bestellen',
      url: 'https://www.lieferando.de/'
    },
    restaurants: [
      {
        name: `Burger King®`,
        image: 'burger-king',
        link: 'https://www.lieferando.de/burger-king'
      },
      {
        name: `KFC`,
        image: 'kfc',
        link: 'https://www.lieferando.de/kfc'
      },
      {
        name: `Domino's`,
        image: 'dominos',
        link: 'https://www.lieferando.de/dominos'
      },
      {
        name: 'Lokale Restaurants',
        image: 'house-icon',
        link: 'https://www.lieferando.de/en/'
      }
    ],
    terms: {
      title: 'Allgemeine Geschäftsbedingungen: ',
      conditions: [
        '- Es gilt ein Mindestbestellwert pro Kunde und Restaurant.',
        `- Gratis Lieferung bei Domino's, KFC, Burger King® nur am 5., 6., 12., 13., 26., und 27. April sowie am 3. und 4. Mai.`,
        '- Es können ggf. Service-Gebühren anfallen.',
        `- Eine Gebühr könnte bei Domino's, KFC, Burger King® auf Lieferungen über eine größere Entfernung anfallen.`
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.yopeso.lieferando&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/gb/app/lieferando-de/id419724490'
    },
    conditions: {
      link: 'AGBs',
      url: 'https://www.lieferando.de/agb'
    },
    privacy: {
      link: 'Datenschutzerklärung',
      url: 'https://www.lieferando.de/privacy-statement'
    },
    copyright: '© 2022 lieferando.de'
  },
  at_en: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.lieferando.at/en/deals/ucl-proposition/'
        },
        {
          logo: 'at',
          url: 'https://www.lieferando.at/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'lieferando',
    title: 'Free delivery on match days ⚽',
    subtitle: `on McDonald's® and local favourites`,
    info: `Get all set for the UEFA Champions League matches with Lieferando. Enjoy free delivery on Tuesdays and Wednesdays on McDonald's® and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area. `,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.lieferando.at/en/'
    },
    restaurants: [
      {
        name: `McDonald's®`,
        image: 'mc-donalds-red',
        link: 'https://www.lieferando.at/en/mcdonalds'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.lieferando.at/en/'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on McDonald's® is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4. `,
        '- Service fees might still apply',
        `- A discounted fee for McDonald's® might apply if order classifies as long distance delivery.`
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.lieferando.at/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=at.lieferservice.android&hl=en_GB&gl=US',
      apple:
        'https://apps.apple.com/at/app/lieferando-at-order-food/id362764499?l=en'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.lieferando.at/en/terms-of-use'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.lieferando.at/en/privacy-statement'
    },
    copyright: '© 2022 Lieferando.at'
  },
  at_de: {
    navbar: {
      logo: 'lieferando-logo',
      country_toggle: [
        {
          logo: 'at',
          url: 'https://www.lieferando.at/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.lieferando.at/en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'lieferando-at',
    title: 'Gratis Lieferung an Spieltagen ⚽',
    subtitle: `Bei McDonald's® & lokalen Favoriten`,
    deal: ``,
    info: `Mach dich bereit für die Spiele der UEFA Champions League mit Lieferando. McDonald's® und lokale Favoriten liefern dienstags und mittwochs kostenlos. Einfach nach “Gratis Lieferung an Spieltagen” filtern und Restaurants in deiner Nähe finden. `,
    matches: {
      title: 'Spieltage:',
      dates: [
        'Viertelfinale, Hinspiele – Dienstag, 5. April und Mittwoch, 6. April',
        'Viertelfinale, Rückspiele – Dienstag, 12. April und Mittwoch, 13. April',
        'Halbfinale, Hinspiele – Dienstag, 26. April und Mittwoch, 27. April',
        'Halbfinale, Rückspiele – Dienstag, 3. Mai und Mittwoch, 4. Mai'
      ],
      outro: 'Bestell dir etwas Köstliches und warte gespannt auf den Anpfiff'
    },
    button: {
      text: 'Jetzt bestellen',
      url: 'https://www.lieferando.at/'
    },
    restaurants: [
      {
        name: `McDonald's®`,
        image: 'mc-donalds-red',
        link: 'https://www.lieferando.at/mcdonalds'
      },
      {
        name: 'Lokalen Favoriten',
        image: 'house-icon',
        link: 'https://www.lieferando.at/'
      }
    ],
    terms: {
      title: 'Allgemeine Geschäftsbedingungen: ',
      conditions: [
        '- Es gilt ein Mindestbestellwert pro Kunde und Restaurant. ',
        `- Kostenlose Lieferung bei McDonald's® nur am 5., 6., 12., 13., 26., und 27. April sowie am 3. und 4. Mai.  `,
        '- Es können ggf. Service-Gebühren anfallen.',
        `- Eine Gebühr könnte bei McDonald's® auf Lieferungen über eine größere Entfernung anfallen.`
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=at.lieferservice.android&hl=en_GB&gl=US',
      apple:
        'https://apps.apple.com/at/app/lieferando-at-order-food/id362764499?l=en'
    },
    conditions: {
      link: 'AGBs',
      url: 'https://www.lieferando.at/agb'
    },
    privacy: {
      link: 'Datenschutzerklärung',
      url: 'https://www.lieferando.at/privacy-statement'
    },
    copyright: '© 2022 Lieferando.at'
  },
  be_en: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/be-en/deals/ucl-proposition/'
        },
        {
          logo: 'nl',
          url: 'https://www.takeaway.com/be/deals/ucl-proposition/'
        },
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/be-fr/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'takeaway',
    title: 'Free delivery on match days ⚽',
    subtitle: 'on big brands and local favourites',
    info: `Get all set for the UEFA Champions League matches with Takeaway.com. Enjoy free delivery on Tuesdays and Wednesdays on Quick, Pizza Hut and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area.`,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.takeaway.com/be-en/'
    },
    restaurants: [
      {
        name: 'Quick',
        image: 'quick-burger',
        link: 'https://www.takeaway.com/be-en/quick'
      },
      {
        name: 'Pizza Hut',
        image: 'pizza-hut',
        link: 'https://www.takeaway.com/be-en/pizza-hut'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.takeaway.com/be-en/'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on Quick and Pizza Hut is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4. `,
        '- Service fees might still apply'
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/be-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=uk.takeaway.android&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/be/app/takeaway-com-belgium/id333214143'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.takeaway.com/be-en/terms-of-use'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/be-en/privacy-statement'
    },
    copyright: '© 2022 Takeaway.com'
  },
  be_nl: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'nl',
          url: 'https://www.takeaway.com/be/deals/ucl-proposition/'
        },
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/be-fr/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/be-en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'takeaway',
    title: 'Gratis levering op matchdagen ⚽',
    subtitle: 'Grote merken en lokale favorieten',
    deal: 'Bij Quick, Pizza Hut en vele favorieten',
    info: `Bereid je voor op de wedstrijden van de UEFA Champions League met Takeaway.com. Geniet van gratis bezorging op dinsdag en woensdag bij Quick, Pizza Hut en vele lokale favorieten. Filter op Wedstrijddag Gratis Bezorging om restaurants in de buurt te vinden.`,
    matches: {
      title: 'Wedstrijddagen:',
      dates: [
        'Kwartfinales, eerste wedstrijd - dinsdag 5 april en woensdag 6 april',
        'Kwartfinales, tweede wedstrijd - dinsdag 12 april en woensdag 13 april',
        'Halve finales, eerste wedstrijd - dinsdag 26 april en woensdag 27 april',
        'Halve finales, tweede wedstrijd - dinsdag 3 mei en woensdag 4 mei'
      ],
      outro:
        'Bestel, maak je klaar voor de wedstrijd en wacht op het fluitsignaal.'
    },
    button: {
      text: 'Bestel nu',
      url: 'https://www.takeaway.com/be/'
    },
    restaurants: [
      {
        name: 'Quick',
        image: 'quick-burger',
        link: 'https://www.takeaway.com/be/quick'
      },
      {
        name: 'Pizza Hut',
        image: 'pizza-hut',
        link: 'https://www.takeaway.com/be/pizza-hut'
      },
      {
        name: 'Lokale favorieten',
        image: 'house-icon',
        link: 'https://www.takeaway.com/be/'
      }
    ],
    terms: {
      title: 'Algemene voorwaarden: ',
      conditions: [
        '- De klant moet de minimale bestelwaarde van het restaurant bereiken. ',
        `- Gratis bezorging bij Quick, Pizza Hut is alleen geldig op 5, 6, 12, 13, 26 en 27 april en op 3 en 4 mei. `,
        '- Servicekosten kunnen nog van toepassing zijn.'
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=uk.takeaway.android&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/be/app/takeaway-com-belgium/id333214143'
    },
    conditions: {
      link: 'Algemene voorwaarden',
      url: 'https://www.takeaway.com/be/algemene-voorwaarden'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/be/privacy-statement'
    },
    copyright: '© 2022 Takeaway.com'
  },
  be_fr: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'fr',
          url: 'https://www.takeaway.com/be-fr/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/be-en/deals/ucl-proposition/'
        },
        {
          logo: 'nl',
          url: 'https://www.takeaway.com/be/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'takeaway',
    title: 'Match = livraison offerte ⚽',
    subtitle: 'Chez de nombreux restaurants',
    deal: `Chez Quick, Pizza Hut et d'autres favoris`,
    info: `Préparez-vous pour la Ligue des champions de l’UEFA avec Takeaway.com. Profitez de la livraison gratuite les mardis et mercredis chez Quick, Pizza Hut et les préférés du coin. Filtrez simplement par « Livraison offerte les jours de match » pour trouver des restaurants dans votre quartier.`,
    matches: {
      title: ' Jours de match :',
      dates: [
        'Quarts de finale, match aller - mardi 5 avril et mercredi 6 avril',
        'Quarts de finale, match retour - mardi 12 avril et mercredi 13 avril',
        'Demi-finales, match aller - mardi 26 avril et mercredi 27 avril',
        'Demi-finales, match retour - mardi 3 mai et mercredi 4 mai'
      ],
      outro: 'Passez commande, faites-vous plaisir et attendez le coup d’envoi.'
    },
    button: {
      text: 'Favoris locaux',
      url: 'https://www.takeaway.com/be-fr/'
    },
    restaurants: [
      {
        name: 'Quick',
        image: 'quick-burger',
        link: 'https://www.takeaway.com/be-fr/quick'
      },
      {
        name: 'Pizza Hut',
        image: 'pizza-hut',
        link: 'https://www.takeaway.com/be-fr/pizza-hut'
      },
      {
        name: 'Favoris locaux',
        image: 'house-icon',
        link: 'https://www.takeaway.com/be-fr/'
      }
    ],
    terms: {
      title: 'Conditions Générales : ',
      conditions: [
        '- Le client doit respecter un montant minimum de commande par restaurant. ',
        `- Livraison gratuite chez Quick, Pizza Hut valable seulement les 5, 6, 12, 13, 26, 27 avril et 3, 4 mai.`,
        '- Des frais de service peuvent s’appliquer.'
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/be-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=uk.takeaway.android&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/be/app/takeaway-com-belgium/id333214143'
    },
    conditions: {
      link: 'Conditions Générales',
      url: 'https://www.takeaway.com/be-fr/conditions-d-utilisation'
    },
    privacy: {
      link: 'Déclaration de confidentialité',
      url: 'https://www.takeaway.com/be-fr/privacy-statement'
    },
    copyright: '© 2022 Takeaway.com'
  },
  ro_en: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/ro-en/deals/ucl-proposition/'
        },
        {
          logo: 'ro',
          url: 'https://www.takeaway.com/ro/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'takeaway',
    title: 'Free delivery on match days ⚽',
    subtitle: 'on big brands and local favourites',
    info: `Get all set for the UEFA Champions League matches with Takeaway.com. Enjoy free delivery on Tuesdays and Wednesdays on KFC, Pizza Hut, Taco Bell, McDonald's® and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area. `,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.takeaway.com/ro-en/'
    },
    restaurants: [
      {
        name: `KFC`,
        image: 'kfc',
        link: 'https://www.takeaway.com/ro-en/kfc'
      },
      {
        name: `Pizza Hut`,
        image: 'pizza-hut',
        link: 'https://www.takeaway.com/ro-en/pizza-hut'
      },
      {
        name: `Taco Bell`,
        image: 'taco-bell',
        link: 'https://www.takeaway.com/ro-en/taco-bell'
      },
      {
        name: `McDonald's`,
        image: 'mc-donalds',
        link: 'https://www.takeaway.com/ro-en/mcdonalds'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.takeaway.com/ro-en/'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on KFC, Pizza Hut, Taco Bell and McDonald's® is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4. `,
        '- Service fees might still apply',
        `- A discounted fee for KFC, Pizza Hut, Taco Bell and McDonald's® might apply if order classifies as long distance delivery.`
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/ro-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=ro.ascendnet.android.agregator&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/ro/app/takeaway-com-romania/id606114791'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.takeaway.com/ro/conditii-de-utilizare'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/ro-en/privacy-statement'
    },
    copyright: '© 2022 Takeaway.com'
  },
  ro_ro: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'ro',
          url: 'https://www.takeaway.com/ro/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/ro-en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'takeaway',
    title: 'Livrare gratuită pentru meci ⚽',
    subtitle: 'La restaurante de top',
    deal: '',
    info: `Pregătește-te pentru meciurile din Liga Campionilor UEFA cu Takeaway.com. Bucură-te de livrare gratuită pentru meci de la KFC, Pizza Hut, Taco Bell și favoritele locale. Filtrează după „Livrare Gratuită pentru meci” pentru a găsi restaurante din zona ta. `,
    matches: {
      title: 'Zile de meci:',
      dates: [
        'Sferturi de finală, prima etapă - marți, 5 aprilie și miercuri 6 aprilie',
        'Sferturi de finală, a doua etapă - marți, 12 aprilie și miercuri 13 aprilie',
        'Semi-finală, prima etapă - marți, 26 aprilie și miercuri 27 aprilie',
        'Semi-finală, a doua etapă - marți, 3 aprilie și miercuri 4 mai'
      ],
      outro:
        'Comandă cu livrare, intră în atmosferă și așteaptă fluierul de start.'
    },
    button: {
      text: 'Comandă acum',
      url: 'https://www.takeaway.com/ro/'
    },
    restaurants: [
      {
        name: `KFC`,
        image: 'kfc',
        link: 'https://www.takeaway.com/ro/kfc'
      },
      {
        name: `Pizza Hut`,
        image: 'pizza-hut',
        link: 'https://www.takeaway.com/ro/pizza-hut'
      },
      {
        name: `Taco Bell`,
        image: 'taco-bell',
        link: 'https://www.takeaway.com/ro/taco-bell'
      },
      {
        name: `McDonald's`,
        image: 'mc-donalds',
        link: 'https://www.takeaway.com/ro/mcdonalds'
      },
      {
        name: 'Favoritele locale',
        image: 'house-icon',
        link: 'https://www.takeaway.com/ro/'
      }
    ],
    terms: {
      title: 'Termeni și condiții: ',
      conditions: [
        '- Clientul trebuie să atingă valoarea minimă de comandă per restaurant. ',
        `- Oferta se aplica numai restaurantelor selectate`,
        '- Este posibil să se aplice taxe de servicii.',
        `- Este posibil să se aplice o taxă pentru KFC, Pizza Hut, Taco Bell în cazul în care comanda este considerată livrare la mare distanță.`
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=ro.ascendnet.android.agregator&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/ro/app/takeaway-com-romania/id606114791'
    },
    conditions: {
      link: 'Termeni și Condiții',
      url: 'https://www.takeaway.com/ro/conditii-de-utilizare'
    },
    privacy: {
      link: 'Declarație de confidențialitate',
      url: 'https://www.takeaway.com/ro/declaratie-privind-confidentialitatea'
    },
    copyright: '© 2022 Takeaway.com'
  },
  bg_bg: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'bg',
          url: 'https://www.takeaway.com/bg/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/bg-en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'takeaway',
    title: 'Безплатна доставка в дни с мачове ⚽',
    subtitle: 'От избрани ресторанти',
    deal: 'От KFC, PizzaLab и други фаворити',
    info: `Подготви се за мачовете от Шампионската лига на УЕФА с Takeaway.com. Наслади се на хапване с безплатна доставка от PizzaLab, KFC или други любими ресторанти. Просто филтрирай по безплатна доставка в деня на мача, за да намериш ресторанти в твоя район. `,
    matches: {
      title: ' Дни на мачове:',
      dates: [
        'Четвъртфинали, първи мач - вторник, 5 април и сряда, 6 април',
        'Четвъртфинали, втори мач - вторник, 12 април и сряда, 13 април',
        'Полуфинали, първи мач - вторник, 26 април и сряда, 27 април',
        'Полуфинали, втори мач - вторник, 3 май и сряда, 4 май'
      ],
      outro: 'Поръчай и тръпни в очакване на първия съдийски сигнал.'
    },
    button: {
      text: 'Поръчай',
      url: 'https://www.takeaway.com/bg'
    },
    restaurants: [
      {
        name: 'KFC',
        image: 'kfc',
        link: 'https://www.takeaway.com/bg/kfc'
      },
      {
        name: 'Pizza Lab',
        image: 'pizza-lab',
        link: 'https://www.takeaway.com/bg/pizzalab'
      },
      {
        name: 'Любими ресторанти',
        image: 'house-icon',
        link: 'https://www.takeaway.com/bg-en'
      }
    ],
    terms: {
      title: 'Условия за ползване:',
      conditions: [
        '- Клиентът трябва да достигне минимална стойност на поръчката за конкретния ресторант. ',
        `- Безплатна доставка от PizzaLab и KFC е валидна за дните 5, 6, 12, 13, 26, 27 април и 3, 4 май. `,
        '- Възможно е да се начислят такси за услуга.',
        `- Такса за PizzaLab, KFC може да бъде начислена, ако поръчката е класифицирана като доставка на дълго разстояние.`
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.bgmenu.android&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/bg/app/takeaway-com-bulgaria/id962261535'
    },
    conditions: {
      link: 'Условия',
      url: 'https://www.takeaway.com/bg/uslovia-na-polzvane'
    },
    privacy: {
      link: 'Декларация за поверителност',
      url: 'https://www.takeaway.com/bg/privacy-statement'
    },
    copyright: '© 2022 Takeaway.com'
  },
  bg_en: {
    navbar: {
      logo: 'takeaway-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.takeaway.com/ro-en/deals/ucl-proposition/'
        },
        {
          logo: 'bg',
          url: 'https://www.takeaway.com/bg/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'takeaway',
    title: 'Free delivery on match days ⚽',
    subtitle: 'on big brands and local favourites',
    info: `Get all set for the UEFA Champions League matches with Just Eat. Enjoy free delivery on Tuesdays and Wednesdays on Pizzalab, KFC and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area. `,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.takeaway.com/bg-en'
    },
    restaurants: [
      {
        name: 'KFC',
        image: 'kfc',
        link: 'https://www.takeaway.com/bg-en/kfc'
      },
      {
        name: 'Pizza Lab',
        image: 'pizza-lab',
        link: 'https://www.takeaway.com/bg-en/pizzalab'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.takeaway.com/bg-en'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on Pizzalab and KFC is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4.`,
        '- Service fees might still apply',
        `- A discounted fee for Pizzalab and KFC might apply if order classifies as long distance delivery.`
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.takeaway.com/bg-en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.bgmenu.android&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/bg/app/takeaway-com-bulgaria/id962261535'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.takeaway.com/bg/uslovia-na-polzvane'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.takeaway.com/bg-en/privacy-statement'
    },
    copyright: '© 2022 Takeaway.com'
  },
  nl_en: {
    navbar: {
      logo: 'thuisbezorgd-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.thuisbezorgd.nl/en/deals/ucl-proposition/'
        },
        {
          logo: 'nl',
          url: 'https://www.thuisbezorgd.nl/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'thuisbezorgd',
    title: 'Free delivery on match days ⚽',
    subtitle: 'on New York Pizza and local favourites',
    info: `Get all set for the UEFA Champions League matches with Thuisbezorgd.nl. Enjoy free delivery on Tuesdays and Wednesdays on New York Pizza and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area. `,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.thuisbezorgd.nl/en/'
    },
    restaurants: [
      {
        name: 'New York Pizza',
        image: 'new-york-pizza',
        link: 'https://www.thuisbezorgd.nl/en/new-york-pizza'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.thuisbezorgd.nl/en/'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        '- Service fees might still apply'
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.thuisbezorgd.nl/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.takeaway.android&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/us/app/thuisbezorgd-nl/id329472759'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.thuisbezorgd.nl/en/terms-of-use'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.thuisbezorgd.nl/en/privacy-statement'
    },
    copyright: '© 2022 Thuisbezorgd'
  },
  nl_nl: {
    navbar: {
      logo: 'thuisbezorgd-logo',
      country_toggle: [
        {
          logo: 'nl',
          url: 'https://www.thuisbezorgd.nl/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.thuisbezorgd.nl/en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'thuisbezorgd',
    title: 'Geniet met gratis bezorging ⚽',
    subtitle: 'New York Pizza en lokale favorieten',
    deal: '',
    info: `Bereid je voor op de wedstrijden van de UEFA Champions League met Thuisbezorgd.nl. Geniet van de wedstrijd met gratis bezorging bij New York Pizza en lokale favorieten. Filter op Wedstrijddag Gratis Bezorging om restaurants in de buurt te vinden.`,
    matches: {
      title: 'Wedstrijddagen:',
      dates: [
        'Kwartfinales, eerste wedstrijd - dinsdag 5 april en woensdag 6 april',
        'Kwartfinales, tweede wedstrijd - dinsdag 12 april en woensdag 13 april',
        'Halve finales, eerste wedstrijd - dinsdag 26 april en woensdag 27 april',
        'Halve finales, tweede wedstrijd - dinsdag 3 mei en woensdag 4 mei'
      ],
      outro: 'Bestel, ga er goed voor zitten en geniet van de wedstrijd.'
    },
    button: {
      text: 'Bestel nu',
      url: 'https://www.thuisbezorgd.nl/'
    },
    restaurants: [
      {
        name: 'New York Pizza',
        image: 'new-york-pizza',
        link: 'https://www.thuisbezorgd.nl/new-york-pizza'
      },
      {
        name: 'Lokale favorieten',
        image: 'house-icon',
        link: 'https://www.thuisbezorgd.nl/'
      }
    ],
    terms: {
      title: 'Algemene voorwaarden: ',
      conditions: [
        '- De klant moet de minimale bestelwaarde per restaurant bereiken.',
        `- Servicekosten kunnen nog van toepassing zijn. `
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.takeaway.android&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/us/app/thuisbezorgd-nl/id329472759'
    },
    conditions: {
      link: 'Algemene voorwaarden',
      url: 'https://www.thuisbezorgd.nl/algemene-voorwaarden'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.thuisbezorgd.nl/privacy-statement'
    },
    copyright: '© 2022 Thuisbezorgd'
  },
  ch_en: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.just-eat.ch/en/deals/ucl-proposition/'
        },
        {
          logo: 'fr',
          url: 'https://www.just-eat.ch/fr/deals/ucl-proposition/'
        },
        {
          logo: 'de',
          url: 'https://www.just-eat.ch/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'just-eat',
    title: 'Free delivery on match days ⚽',
    subtitle: 'on Burger King® and local favourites',
    info: `Get all set for the UEFA Champions League matches with Just Eat. Enjoy free delivery on Tuesdays and Wednesdays on Burger King® and local favourites. Simply filter by Match Day Free Delivery to find restaurants in your area. `,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.just-eat.ch/en/'
    },
    restaurants: [
      {
        name: 'Burger King',
        image: 'burger-king',
        link: 'https://www.just-eat.ch/en/burger-king'
      },
      {
        name: 'Local favourites',
        image: 'house-icon',
        link: 'https://www.just-eat.ch/en/'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- Free delivery on Burger King® is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4. `,
        '- Service fees might still apply',
        `- A discounted fee for Burger King® might apply if order classifies as long distance delivery.`
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.just-eat.ch/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google: 'https://play.google.com/store/apps/details?id=com.eat.ch',
      apple: 'https://apps.apple.com/us/app/just-eat-food-delivery/id566347057'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.just-eat.ch/en/terms-of-use'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.just-eat.ch/en/privacy-statement'
    },
    copyright: '© 2022 Takeaway.com'
  },
  ch_de: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'de',
          url: 'https://www.just-eat.ch/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.ch/en/deals/ucl-proposition/'
        },
        {
          logo: 'fr',
          url: 'https://www.just-eat.ch/fr/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'just-eat',
    title: 'Gratis-Lieferung an Spieltagen ⚽',
    subtitle: 'Bei Burger King® und lokalen Favoriten',
    deal: '',
    info: `Mach dich bereit für die Spiele der UEFA Champions League mit Just Eat. Burger King® und lokale Favoriten liefern dienstags und mittwochs kostenlos. Einfach nach "Gratis Lieferung an Spieltagen" filtern und Restaurants in deiner Gegend finden`,
    matches: {
      title: 'Spieltage:',
      dates: [
        'Viertelfinale, Hinspiele – Dienstag, 5. April und Mittwoch, 6. April',
        'Viertelfinale, Rückspiele – Dienstag, 12. April und Mittwoch, 13. April',
        'Halbfinale, Hinspiele – Dienstag, 26. April und Mittwoch, 27. April',
        'Halbfinale, Rückspiele – Dienstag, 3. Mai und Mittwoch, 4. Mai'
      ],
      outro: 'Bestell dir etwas feines und warte gespannt auf den Anpfiff.'
    },
    button: {
      text: 'Jetzt bestellen',
      url: 'https://www.just-eat.ch/en/'
    },
    restaurants: [
      {
        name: 'Burger King®',
        image: 'burger-king',
        link: 'https://www.just-eat.ch/burger-king'
      },
      {
        name: 'Lokale Favoriten',
        image: 'house-icon',
        link: 'https://www.just-eat.ch/'
      }
    ],
    terms: {
      title: 'Allgemeine Geschäftsbedingungen: ',
      conditions: [
        '- Es gilt ein Mindestbestellwert pro Kunde und Restaurant. ',
        '- Bei Es können ggf. Service-Gebühren anfallen.',
        `- Eine Gebühr könnte bei Burger King® auf Lieferungen über eine grössere Entfernung anfallen.`
      ]
    },
    app: {
      google: 'https://play.google.com/store/apps/details?id=com.eat.ch',
      apple: 'https://apps.apple.com/gb/app/just-eat-food-delivery/id566347057'
    },
    conditions: {
      link: 'AGBs',
      url: 'https://www.just-eat.ch/agb'
    },
    privacy: {
      link: 'Datenschutzerklärung',
      url: 'https://www.just-eat.ch/privacy-statement'
    },
    copyright: '© 2022 JustEat'
  },
  ch_fr: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'fr',
          url: 'https://www.just-eat.ch/fr/deals/ucl-proposition/'
        },
        {
          logo: 'de',
          url: 'https://www.just-eat.ch/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.just-eat.ch/en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'just-eat',
    title: 'Matchs = livraison gratuite ⚽',
    subtitle: 'Chez Burger King® et de nombreux restaurants',
    deal: '',
    info: `Soyez prêt pour les matchs de Ligue des champions de l’UEFA avec Just Eat. Profitez de la livraison gratuite les mardis et mercredis chez Burger King® et les meilleures adresses locales. Utilisez simplement le filtre «Livraison offerte les jours de match» pour trouver des restaurants dans votre quartier. `,
    matches: {
      title: 'Jours de match:',
      dates: [
        'Quarts de finale, match aller - mardi 5 avril et mercredi 6 avril',
        'Quarts de finale, match retour - mardi 12 avril et mercredi 13 avril',
        'Demi-finales, match aller - mardi 26 avril et mercredi 27 avril',
        'Demi-finales, match retour - mardi 3 mai et mercredi 4 mai'
      ],
      outro: 'Passez commande, faites-vous plaisir et attendez le coup d’envoi.'
    },
    button: {
      text: 'Commandez maintenant',
      url: 'https://www.just-eat.ch/fr/'
    },
    restaurants: [
      {
        name: 'Burger King®',
        image: 'burger-king',
        link: 'https://www.just-eat.ch/fr/burger-king'
      },
      {
        name: 'Vos restaurants préférés',
        image: 'house-icon',
        link: 'https://www.just-eat.ch/fr/'
      }
    ],
    terms: {
      title: 'Conditions Générales: ',
      conditions: [
        '- Le client doit respecter un montant minimum de commande par restaurant. ',
        `- Livraison gratuite chez Burger King® et les meilleures adresses près de chez vous valable seulement les 5, 6, 12, 13, 26, 27 avril et 3, 4 mai.`,
        '- Des frais de service peuvent s’appliquer.',
        `- Des frais pour Burger King® peuvent s’appliquer si la commande est classée comme une livraison longue distance.`
      ]
    },
    app: {
      google: 'https://play.google.com/store/apps/details?id=com.eat.ch',
      apple:
        'https://apps.apple.com/us/app/just-eat-fr-livraison-repas/id911826430'
    },
    conditions: {
      link: `Conditions Générales`,
      url: 'https://www.just-eat.ch/fr/conditions-d-utilisation'
    },
    privacy: {
      link: `Déclaration de confidentialité`,
      url: 'https://www.just-eat.ch/fr/privacy-statement'
    }
  },
  pl_en: {
    navbar: {
      logo: 'pyszne-logo',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://www.pyszne.pl/en/deals/ucl-proposition/'
        },
        {
          logo: 'pl',
          url: 'https://www.pyszne.pl/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'pyszne',
    title: '25% off on all Domino’s pizzas on Pyszne.pl ⚽',
    subtitle: 'Only on match days',
    info: `Pizza fans! Get all set for the UEFA Champions League matches with Pyszne.pl. Enjoy a tasty 25% off any Domino’s pizzas on Tuesdays and Wednesdays.`,
    matches: {
      title: 'Match days:',
      dates: [
        'Quarter-finals, first leg - Tuesday 5 April and Wednesday 6 April',
        'Quarter-finals, second leg - Tuesday 12 April and Wednesday 13 April',
        'Semi-finals, first leg - Tuesday 26 April and Wednesday 27 April',
        'Semi-finals, second leg - Tuesday 3 May and Wednesday 4 May'
      ],
      outro: 'Order in, get excited and wait for that first whistle.'
    },
    button: {
      text: 'Order now',
      url: 'https://www.pyszne.pl/en/'
    },
    restaurants: [
      {
        name: `Domino's`,
        image: 'dominos',
        link: 'https://www.pyszne.pl/en/dominos'
      }
    ],
    terms: {
      title: 'Terms and Conditions:',
      conditions: [
        '- Customer must reach minimum order value per restaurant.',
        `- 25% off on Domino's is only valid on April 5, 6, 12, 13, 26, 27 and May 3, 4. `,
        '- Service fees might still apply'
      ]
    },
    cookie: {
      text:
        'We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website.',
      url: 'https://www.pyszne.pl/en/cookiestatement',
      url_text: 'Learn more about our cookies policy.',
      button: 'OK'
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.yourdelivery.pyszne&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/us/app/pyszne-pl/id1039818673'
    },
    conditions: {
      link: 'Terms & Conditions',
      url: 'https://www.pyszne.pl/en/terms-of-use'
    },
    privacy: {
      link: 'Privacy statement',
      url: 'https://www.pyszne.pl/en/privacy-statement'
    },
    copyright: '© 2022 Pyszne.pl'
  },
  pl_pl: {
    navbar: {
      logo: 'pyszne-logo',
      country_toggle: [
        {
          logo: 'pl',
          url: 'https://www.pyszne.pl/deals/ucl-proposition/'
        },
        {
          logo: 'gb',
          url: 'https://www.pyszne.pl/en/deals/ucl-proposition/'
        }
      ]
    },
    logo: 'pyszne',
    title: '25% zniżki na pizzę w Domino’s ⚽',
    subtitle: 'Tylko w dni meczowe',
    info: `Fani pizzy! Przygotujcie się na dni meczowe Ligi Mistrzów UEFA z Pyszne.pl. We wtorki i środki 25% zniżki na pizze z Domino’s.`,
    matches: {
      title: 'Dni meczowe:',
      dates: [
        'Ćwierćfinały, pierwszy mecz – wtorek, 5 kwietnia i środa, 6 kwietnia',
        'Ćwierćfinały, drugi mecz – wtorek, 12 kwietnia i środa, 13 kwietnia',
        'Półfinały, pierwszy mecz – wtorek, 26 kwietnia i środa, 27 kwietnia',
        'Półfinały, pierwszy mecz – wtorek, 3 maja i środa, 4 maja'
      ],
      outro: 'Zamów i czekaj na pierwszy gwizdek'
    },
    button: {
      text: 'Zamów teraz',
      url: 'https://www.pyszne.pl/'
    },
    restaurants: [
      {
        name: `Domino's`,
        image: 'dominos',
        link: 'https://www.pyszne.pl/pizza-dominium'
      }
    ],
    terms: {
      title: 'Regulamin',
      conditions: [
        '- Klient musi osiągnąć minimalną wartość zamówienia ustalaną przez restauracje ',
        `- Zniżka -25% na wszystkie pizze obowiązuje wyłącznie 5, 6, 12, 13, 26, 27 kwietnia i 3, 4 maja. `,
        '- Opłata za usługę może obowiązywać',
        '- Opłata może zostać zastosowana, jeśli zamówienie zostanie określone przez Domino’s jako dostawa na dużą odległość.',
        '- Zniżka nie łączy sie z innymi promocjami.'
      ]
    },
    app: {
      google:
        'https://play.google.com/store/apps/details?id=com.yourdelivery.pyszne&hl=en_GB&gl=US',
      apple: 'https://apps.apple.com/us/app/pyszne-pl/id1039818673'
    },
    conditions: {
      link: 'Regulamin',
      url: 'https://www.pyszne.pl/regulamin'
    },
    privacy: {
      link: 'Polityka prywatnosci',
      url: 'https://www.pyszne.pl/polityka-prywatnosci'
    },
    copyright: '© 2022 Pyszne.pl'
  }
}
